import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LogoImage from './LogoImage';
import { Button, Icon, Popup } from 'semantic-ui-react';
import styles from './Logo.scss';

class LogoComponent extends Component {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    deleteLogo: PropTypes.func.isRequired,
    openPicker: PropTypes.func.isRequired,
    url: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      hovering: false
    };
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  onMouseOver() {
    if (!this.state.hovering) this.setState({ hovering: true });
  }

  onMouseOut() {
    if (this.state.hovering) this.setState({ hovering: false });
  }

  render() {
    const { canEdit, deleteLogo, openPicker, url } = this.props;

    const { hovering } = this.state;
    const editIcon = (
      <Icon
        name='pencil'
        onClick={openPicker}
        className={styles.logoIcon}
      />
    );
    const deleteIcon = (
      <Icon
        name='trash alternate'
        onClick={deleteLogo}
        className={styles.logoIcon}
      />
    );

    return (
      <div>
        {url &&
          <div
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            style={{ marginBottom: '0.5em', display: 'flex' }}
          >
            <div><LogoImage src={url} /></div>
            {canEdit &&
              <div
                style={{ visibility: hovering ? 'visible' : 'hidden', flex: 1 }}
                className={styles.logoActions}
              >
                <div style={{ marginBottom: '1em' }}>
                  <Popup
                    trigger={editIcon}
                    on='hover'
                    inverted
                    content='Edit Logo'
                    position='right center'
                  />
                </div>
                <div>
                  <Popup
                    trigger={deleteIcon}
                    on='hover'
                    inverted
                    content='Delete Logo'
                    position='right center'
                  />
                </div>
              </div>}
          </div>}
        {!url && canEdit &&
          <div style={{ marginBottom: '1em' }}>
            <Button
              basic
              icon='upload'
              content='Upload Logo'
              onClick={openPicker}
            />
          </div>}
      </div>
    );
  }
}

export default LogoComponent;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Logo/Logo.js